import { listFriends } from "@bn-games/social-client";

/**
 * Short enough that a friend added on /friends in another tab shows up by the
 * next match, long enough that GameStateOverlay rebuilding its body on every
 * delta (and mahjong's per-hand result modal) share one `/friends/list` call.
 */
const FRIEND_IDS_TTL_MS = 60_000;

interface CacheEntry {
  readonly fetchedAt: number;
  readonly ids: Promise<ReadonlySet<string> | null>;
}

let cache: CacheEntry | null = null;

/**
 * The userIds the caller already follows, or `null` when the list can't be
 * read (signed out, network error) — callers then fall back to offering
 * every candidate, which is what they did before this filter existed.
 */
export function getFriendIds(): Promise<ReadonlySet<string> | null> {
  const now = Date.now();
  if (cache !== null && now - cache.fetchedAt < FRIEND_IDS_TTL_MS) return cache.ids;
  const ids = listFriends().then((result) =>
    result.ok ? new Set(result.value.map((friend) => friend.userId)) : null,
  );
  cache = { fetchedAt: now, ids };
  return ids;
}

/** Called after a successful add so the next control built drops that opponent. */
export function invalidateFriendIds(): void {
  cache = null;
}
